import { Link } from "react-router-dom";
import { ReactComponent as FooterLogo } from "../assets/FooterSvg-01.svg";
const Footer = (cyYear) => {
  console.log(cyYear);
  return (
    <footer className="bg-[#08193f] text-white">
      <div className="container mx-auto py-14 px-6">
        <div className="grid md:grid-cols-8 grid-cols-1 gap-7">
          <div className="lg:col-span-4 col-span-8 ml-6">
            <a href="/">
              <FooterLogo
                alt="Rising Sun Judo Club Logo"
                className="w-[200px] text-white"
              />
            </a>
            <p className="mt-6">
              Rising Sun Judo Club For ages 7* and up, based in Worthing
              (Sussex)
            </p>
          </div>
          <div className="lg:col-span-2 md:col-span-4 col-span-12">
            <h5 className="px-6 tracking-wide font-bold">The Club</h5>
            <ul className="list-none mt-6 space-y-2">
              <li>
                <Link to="/">
                  <li
                    className="py-1 px-6 text-white hover:text-[#08193f] hover:bg-white transition-all ease-in-out duration-300"
                    href="/"
                  >
                    Home
                  </li>
                </Link>
              </li>
              <li>
                <Link to="/club">
                  <li
                    className="py-1 px-6 text-white hover:text-[#08193f] hover:bg-white transition-all ease-in-out duration-300"
                    href="/"
                  >
                    Club
                  </li>
                </Link>
              </li>
              <li>
                <Link to="/venue-fees">
                  <li
                    className="py-1 px-6 text-white hover:text-[#08193f] hover:bg-white transition-all ease-in-out duration-300"
                    href="/"
                  >
                    Venue
                  </li>
                </Link>
              </li>
              <li>
                <Link to="/team">
                  <li
                    className="py-1 px-6 text-white hover:text-[#08193f] hover:bg-white transition-all ease-in-out duration-300"
                    href="/"
                  >
                    RSJC Team
                  </li>
                </Link>
              </li>
              <li>
                <Link to="/calendar">
                  <li
                    className="py-1 px-6 text-white hover:text-[#08193f] hover:bg-white transition-all ease-in-out duration-300"
                    href="/"
                  >
                    Calendar
                  </li>
                </Link>
              </li>
              <li>
                <Link to="/gallery">
                  <li
                    className="py-1 px-6 text-white hover:text-[#08193f] hover:bg-white transition-all ease-in-out duration-300"
                    href="/"
                  >
                    Gallery
                  </li>
                </Link>
              </li>
              <li>
                <Link to="/links">
                  <li
                    className="py-1 px-6 text-white hover:text-[#08193f] hover:bg-white transition-all ease-in-out duration-300"
                    href="/"
                  >
                    Links
                  </li>
                </Link>
              </li>
            </ul>
          </div>
          <div className="lg:col-span-2 md:col-span-4 col-span-12">
            <h5 className="px-6 tracking-wide font-bold">Important Links</h5>
            <ul className="list-none mt-6 space-y-2">
              <li>
                <Link to="/privacy">
                  <li
                    className="py-1 px-6 text-white hover:text-[#08193f] hover:bg-white transition-all ease-in-out duration-300"
                    href="/"
                  >
                    Privacy Policy
                  </li>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* <div className="border-t border-slate-700"> */}
      <div className="md:text-left text-center container mx-auto py-7 px-6">
        <p mb-6>Copyright Rising Sun Judo Club {cyYear.year}</p>
      </div>
      {/* </div> */}
    </footer>
  );
};

export default Footer;
